class TeaserNewsletter {
	constructor() {
		// eslint-disable-next-line no-console
		console.log("TeaserNewsletter::initialize()")

		this.component = document.querySelector(".bb-teaser-newsletter")
		this.form = this.component.querySelector("form")

		this.inputfield = this.form.querySelector("input")
		this.submitButton = this.form.querySelector("button.form__submit")

		this._init()
	}

	_init() {
		if (this.inputfield) {
			this.inputfield.addEventListener("focusin", () =>
				$(this.submitButton.closest(".form__submit-container")).slideDown(),
			)
		}
	}
}

export default TeaserNewsletter
